import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cursor-3, arrow"} maskId="square-filled-radius-0-stroke-1-IconCursor3"><path d="M20.3928 9.3143L2.11328 2.11328L9.3143 20.3928L12.25 17.4571L17 22.2071L22.2071 17L17.4571 12.25L20.3928 9.3143Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCursor3;
